module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cvip-alert-wrap"
  }, [_c('div', {
    staticClass: "cvip-alert",
    style: ({
      width: _vm.widthnew,
      height: _vm.heightnew,
      margin: _vm.marginnew
    })
  }, [_c('div', {
    staticClass: "alert-hd"
  }, [(_vm.title) ? _c('span', {
    staticClass: "alert-title"
  }, [_vm._v(_vm._s(_vm.title || ''))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "close-btn",
    on: {
      "click": _vm.onHide
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "alert-bd"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.buttonTxt) ? _c('div', {
    staticClass: "alert-ft"
  }, [(_vm.cancelBtnTxt) ? _c('span', {
    staticClass: "alert-btn cancel-btn",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelBtnTxt))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "alert-btn",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(_vm._s(_vm.buttonTxt || ''))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddb78db4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert/Alert.vue
// module id = G0mj
// module chunks = 1